import { createClient } from "@supabase/supabase-js";

// A5: capture a password-recovery callback before the Supabase client consumes the URL hash (detectSessionInUrl).
// Defensive: App's mount check then still sees the recovery even if the client has already cleared the hash.
// Verified on Staging Preview 2026-10-28: a reset link opened in a new tab lands on Set New Password (3/3).
export const RECOVERY_CALLBACK_AT_LOAD =
  typeof window !== "undefined" &&
  /(^|[#&?])type=recovery(&|$)/.test(`${window.location?.hash || ""}&${window.location?.search || ""}`);

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
);